<template>
  <div>
    <el-card class="ibox">
      <div slot="header" class="flex justify-between">
        <span>商品信息</span>
      </div>
      <div class="">
        <el-form :model="editProductInfo" label-width="120px">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="商品名称" prop="prodName">
                <el-input v-model="editProductInfo.prodName" placeholder="必填，请填写商品名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="商品分组" prop="categoryId">
                <el-select v-model="editProductInfo.categoryId" style="width:100%" placeholder="必填，请选择商品分组">
                  <el-option disabled value="">必填，请选择商品分组</el-option>
                  <el-option v-for="(item,index) in editProductInfo.productCategorys" 
                    :key="index" 
                    :label="item.categoryName" 
                    :value="item.categoryId">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="单位" prop="unitName">
                <el-input v-model="editProductInfo.unitName" placeholder="选填，请填写单位"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="排序" prop="sort">
                <el-input v-model="editProductInfo.sort" type="number" placeholder="选填，请填写排序"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="关键词" prop="keyword">
                <el-input v-model="editProductInfo.keyword" 
                  placeholder="必填，请填写关键词,多个关键词用;分隔"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="text-left">
              <el-form-item label="手机菜单" prop="hktIds">
                <el-checkbox-group v-model="editProductInfo.hktIds">
                  <el-checkbox v-for="(item,index) in editProductInfo.housekeepingTypes" 
                    :key="index" 
                    :label="item.hktId">
                    {{item.hktName}}
                  </el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="仓库" prop="shId">
                <el-select v-model="editProductInfo.shId" 
                  @change="_changeShopHouse(editProductInfo.shId)"
                  style="width:100%" 
                  placeholder="请选择仓库">
                  <el-option disabled value="">请选择仓库</el-option>
                  <el-option v-for="(item,index) in editProductInfo.shopHouses" 
                    :key="index" 
                    :label="item.shName" 
                    :value="item.shId">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="text-left">
              <el-form-item label="库存警告数量" prop="warnStock">
                <el-input-number v-model="editProductInfo.warnStock" 
                  placeholder="必填，请填写库存警告数量"></el-input-number>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <el-form-item label="商品简介" prop="prodDesc">
                <el-input type="textarea" 
                  v-model="editProductInfo.prodDesc" 
                  :rows="3"
                  maxlength="250"
                  placeholder="必填，请填写商品简介"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-card>

    <el-card class="ibox">
      <div slot="header" class="flex justify-between">
        <span>商品图片</span>
      </div>
      <div class="">
        <el-form :model="editProductInfo" label-width="120px">
          <el-row>
            <el-col :span="24">
              <el-form-item label="商品封面">
                <upload-image-url 
                  ref="editProductCover"
                  :image-count="1"
                  @notifyUploadCoverImage="handleCoverImageUpload">
                </upload-image-url>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="商品轮播">
                <upload-image-url 
                  ref="editProductCarouselFigure"
                  :image-count="3"
                  @notifyUploadCoverImage="handleCarouselImageUpload">
                </upload-image-url>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-card>

    <el-card class="ibox">
      <div slot="header" class="flex justify-between">
        <span>商品规格</span>
        <el-button type="primary" size="small" style="float:right" @click="_openEditChooseSpecModal">
          <i class="el-icon-plus"></i>添加
        </el-button>
      </div>
      <div class="">
        <el-table :data="editProductInfo.productSpecs" border style="width:100%">
          <el-table-column prop="specName" label="规格名称" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.specName" placeholder="请输入规格名称"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="stock" label="库存" align="center">
            <template slot-scope="scope">
              <el-input-number v-model="scope.row.stock"></el-input-number>
            </template>
          </el-table-column>
          <el-table-column prop="sales" label="销量" align="center">
            <template slot-scope="scope">
              <el-input-number v-model="scope.row.sales"></el-input-number>
            </template>
          </el-table-column>
          <el-table-column prop="price" label="价格/积分" align="center">
            <template slot-scope="scope">
              <el-input-number v-model="scope.row.price"></el-input-number>
            </template>
          </el-table-column>
          <el-table-column prop="costPrice" label="成本价" align="center">
            <template slot-scope="scope">
              <el-input-number v-model="scope.row.costPrice"></el-input-number>
            </template>
          </el-table-column>
          <el-table-column prop="ownerPrice" label="业主价" align="center">
            <template slot-scope="scope">
              <el-input-number v-model="scope.row.ownerPrice"></el-input-number>
            </template>
          </el-table-column>
          <el-table-column prop="vipPrice" label="会员价格" align="center">
            <template slot-scope="scope">
              <el-input-number v-model="scope.row.vipPrice"></el-input-number>
            </template>
          </el-table-column>
          <el-table-column prop="otPrice" label="市场价" align="center">
            <template slot-scope="scope">
              <el-input-number v-model="scope.row.otPrice"></el-input-number>
            </template>
          </el-table-column>
          <el-table-column prop="deduction" label="抵扣金" align="center">
            <template slot-scope="scope">
              <el-input-number v-model="scope.row.deduction"></el-input-number>
            </template>
          </el-table-column>
          <el-table-column prop="barCode" label="条形码" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.barCode"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="180">
            <template slot-scope="scope">
              <el-button type="danger" size="mini" @click="_openEditDeleteProductSpec(scope.row)">
                删除
              </el-button>
              <el-button v-if="scope.row.isDefault != 'T'" type="primary" size="mini"
                @click="_doEditDefaultProductSpec(editProductInfo, scope.row)">
                默认规格
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin-top:15px;">
          <span>抵扣金：商品购买时抵扣金会自动送客户用来 缴相应的物业费停车费</span>
        </div>
      </div>
    </el-card>

    <el-card class="ibox">
      <div slot="header" class="flex justify-between">
        <span>商品扩展</span>
      </div>
      <div class="">
        <el-form :model="editProductInfo" label-width="120px">
          <el-row>
            <el-col :span="24">
              <el-form-item label="商品状态">
                <el-select v-model="editProductInfo.state" style="width:100%">
                  <el-option label="选填，请选择状态" value="" disabled></el-option>
                  <el-option label="未上架" value="1001"></el-option>
                  <el-option label="上架" value="2002"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <el-form-item label="同步时商品自动上下架">
                <el-radio-group v-model="editProductInfo.syncAutoShelfOn">
                  <el-radio :label="true">开启</el-radio>
                  <el-radio :label="false">关闭</el-radio>
                </el-radio-group>
                <div class="form-tip">
                  开启后允许第三方同步库存时根据库存自动修改上下架；关闭后将锁定上下架状态，同步时不再自动修改上下架。
                </div>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <el-form-item label="商品详情">
                <RichTextEditor ref="richTextEditor" v-model="editProductInfo.content" @input="handleContentChange" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

        <div style="margin-top:20px;text-align:right;">
          <el-button type="warning" @click="_closeEditProduct()">
            取消
          </el-button>
          <el-button type="primary" @click="saveProductInfo()">
            <i class="el-icon-check"></i>保存
          </el-button>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { getDict } from '@/api/shop/shopApi'
import { getShopId,getAreaCode } from '@/api/shop/shopApi'
import UploadImageUrl from '@/components/system/UploadImageUrl'
import RichTextEditor from '@/components/system/RichTextEditor.vue'
import { 
  updateProduct, 
  queryProduct, 
  queryProductCategory, 
  queryHousekeepingType, 
  queryShopHouse,
  queryProductH5Menu,
  uploadFile
} from '@/api/goods/productApi'


export default {
  name: 'EditProduct',
  components: {
    UploadImageUrl,
    RichTextEditor
  },
  data() {
    return {
      editProductInfo: {
        shId: '',
        shName: '',
        productId: '',
        warnStock: '',
        categoryId: '',
        prodName: '',
        prodDesc: '',
        keyword: '',
        barCode: '1',
        unitName: '',
        sort: '',
        isPostage: '2',
        postage: '0.00',
        productCategorys: [],
        content: '',
        states: [],
        state: '',
        syncAutoShelfOn: true,
        coverPhoto: '',
        carouselFigurePhoto: [],
        productSpecs: [],
        areaCode: '',
        distributionModes: [],
        housekeepingTypes: [],
        shopHouses: [],
        hktIds: []
      }
    }
  },
  created() {
    this.editProductInfo.productId = this.$route.query.productId
    this.editProductInfo.shopId = getShopId()
    this.editProductInfo.areaCode = getAreaCode()
    this._initEditProduct()
  },
  methods: {
    _initEditProduct() {
      this._listEditProducts({
        productId: this.editProductInfo.productId
      })
      this._listProductH5Menu({
        productId: this.editProductInfo.productId
      })
      this._listShopHouses()
      this._listEditHousekeepingTypes()
      this._listEditProductCategorys()
      
      getDict('product', "state").then(data => {
        this.editProductInfo.states = data.data
      })
      console.log(this.editProductInfo.areaCode)
    },
    handleContentChange(content) {
      this.editProductInfo.content = content
    },
    handleCoverImageUpload(photos) {
      if (photos.length > 0) {
        this.editProductInfo.coverPhoto = photos[0]
      } else {
        this.editProductInfo.coverPhoto = ''
      }
    },
    handleCarouselImageUpload(photos) {
      this.editProductInfo.carouselFigurePhoto = []
      photos.forEach(p => {
        this.editProductInfo.carouselFigurePhoto.push(p)
      })
    },
    
    // 获取商品详情
    async _listEditProducts(params) {
      try {
        const res = await queryProduct({
          page: 1,
          row: 1,
          productId: params.productId
        })
        
        if (res.code === 0 && res.data.length > 0) {
          const product = res.data[0]
          Object.assign(this.editProductInfo, product)
          this.editProductInfo.syncAutoShelfOn = product.syncStateLock != '2002'
          
          // 处理封面图片
          if (product.coverPhoto) {
            this.$refs.editProductCover.setImages([product.coverPhoto])
          }
          
          // 处理轮播图片
          if (product.carouselFigurePhotos) {
            this.$refs.editProductCarouselFigure.setImages(product.carouselFigurePhotos)
              this.editProductInfo.carouselFigurePhoto = []
              product.carouselFigurePhotos.forEach(p => {
                  this.editProductInfo.carouselFigurePhoto.push(p)
              })
          }
          
          // 处理商品规格
          if (product.productSpecValues) {
            this.editProductInfo.productSpecs = product.productSpecValues.map(item => {
              let specValue = ''
              if (item.productSpecDetails) {
                item.productSpecDetails.forEach(detail => {
                  specValue += (detail.detailValue + "/")
                })
              }
              return {
                ...item,
                specValue: specValue
              }
            })
          }
          //
          if(product.content){
            this.$refs.richTextEditor.setContent(product.content)
          }
        }
      } catch (error) {
        console.error('获取商品详情失败:', error)
        this.$message.error('获取商品详情失败')
      }
    },
    
    // 获取商品H5菜单
    async _listProductH5Menu(params) {
      try {
        const res = await queryProductH5Menu({
          page: 1,
          row: 30,
          productId: params.productId
        })
        
        if (res.code === 0) {
          this.editProductInfo.hktIds = res.data.map(item => item.hktId)
        }
      } catch (error) {
        console.error('获取商品H5菜单失败:', error)
      }
    },
    
    // 获取仓库列表
    async _listShopHouses() {
      try {
        const params = {
          page: 1,
          row: 100,
          shopId: this.editProductInfo.shopId
        }
        const res = await queryShopHouse(params)
        this.editProductInfo.shopHouses = res.data
      } catch (error) {
        console.error('获取仓库列表失败:', error)
      }
    },
    
    // 获取家政类型列表
    async _listEditHousekeepingTypes() {
      try {
        const res = await queryHousekeepingType({
          page: 1,
          row: 30,
          typeCd: '2002',
          shopId: '9999',
          skipType: '3'
        })
        
        if (res.code === 0) {
          this.editProductInfo.housekeepingTypes = res.data
        }
      } catch (error) {
        console.error('获取家政类型列表失败:', error)
      }
    },
    
    // 获取商品分类列表
    async _listEditProductCategorys() {
      try {
        const res = await queryProductCategory({
          page: 1,
          row: 50,
          shopId: this.editProductInfo.shopId
        })
        
        if (res.code === 0) {
          this.editProductInfo.productCategorys = res.data
        }
      } catch (error) {
        console.error('获取商品分类列表失败:', error)
      }
    },
    
    // 添加商品规格
    _openEditChooseSpecModal() {
      const newProductSpec = {
        specCd: "0",
        stock: "0",
        sales: "0",
        price: "0.00",
        costPrice: "0.00",
        ownerPrice: "0.00",
        vipPrice: "0.00",
        otPrice: "0.00",
        deduction: "0.00",
        isDefault: "F",
        barCode: ""
      }
      
      this.editProductInfo.productSpecs.push(newProductSpec)
      
      // 检查是否有默认规格，如果没有则设置第一个为默认
      let hasDefault = false
      this.editProductInfo.productSpecs.forEach(item => {
        if (item.isDefault === "T") {
          hasDefault = true
        }
      })
      
      if (!hasDefault && this.editProductInfo.productSpecs.length > 0) {
        this.editProductInfo.productSpecs[0].isDefault = "T"
      }
    },
    
    // 删除商品规格
    _openEditDeleteProductSpec(productSpec) {
      const index = this.editProductInfo.productSpecs.indexOf(productSpec)
      if (index > -1) {
        this.editProductInfo.productSpecs.splice(index, 1)
      }
      
      // 检查是否有默认规格，如果没有则设置第一个为默认
      let hasDefault = false
      this.editProductInfo.productSpecs.forEach(item => {
        if (item.isDefault === "T") {
          hasDefault = true
        }
      })
      
      if (!hasDefault && this.editProductInfo.productSpecs.length > 0) {
        this.editProductInfo.productSpecs[0].isDefault = "T"
      }
    },
    
    // 设置默认规格
    _doEditDefaultProductSpec(product, defaultProductSpec) {
      if (product.productSpecs) {
        product.productSpecs.forEach(item => {
          item.isDefault = "F"
        })
      }
      defaultProductSpec.isDefault = "T"
    },
    
    // 仓库变更处理
    _changeShopHouse(shopHouseId) {
      if (this.editProductInfo.shopHouses) {
        this.editProductInfo.shopHouses.forEach(item => {
          if (item.shId === shopHouseId) {
            this.editProductInfo.shName = item.shName
          }
        })
      }
    },
    
    // 商品验证
    editProductValidate() {
      // 检查必填字段
      if (!this.editProductInfo.categoryId) {
        this.$message.error('商品大类不能为空')
        return false
      }
      
      if (!this.editProductInfo.prodName) {
        this.$message.error('商品名称不能为空')
        return false
      }
      
      if (this.editProductInfo.prodName.length > 128) {
        this.$message.error('商品名称不能超过128位')
        return false
      }
      
      if (!this.editProductInfo.prodDesc) {
        this.$message.error('商品简介不能为空')
        return false
      }
      
      if (this.editProductInfo.prodDesc.length > 256) {
        this.$message.error('商品简介不能超过256位')
        return false
      }
      
      if (!this.editProductInfo.keyword) {
        this.$message.error('关键词不能为空')
        return false
      }
      
      if (this.editProductInfo.keyword.length > 256) {
        this.$message.error('关键词不能超过256位')
        return false
      }
      
      if (this.editProductInfo.barCode && this.editProductInfo.barCode.length > 15) {
        this.$message.error('产品条码不能超过15位')
        return false
      }
      
      if (!this.editProductInfo.shId) {
        this.$message.error('仓库不能为空')
        return false
      }
      
      if (this.editProductInfo.unitName && this.editProductInfo.unitName.length > 32) {
        this.$message.error('单位不能超过32位')
        return false
      }
      
      // 检查是否有默认规格
      let hasDefault = false
      if (this.editProductInfo.productSpecs) {
        this.editProductInfo.productSpecs.forEach(item => {
          if (item.isDefault === 'T') {
            hasDefault = true
          }
        })
      }
      
      if (!hasDefault) {
        this.$message.error('未选择默认规格')
        return false
      }
      
      return true
    },
    
    // 保存商品信息
    async saveProductInfo() {
      if (!this.editProductValidate()) {
        return
      }
      
      try {
        const res = await updateProduct(this.editProductInfo)
        
        if (res.code === 0) {
          this.$message.success('修改成功')
          this._closeEditProduct()
          this.$emit('refresh')
        } else {
          this.$message.error(res.msg || '修改失败')
        }
      } catch (error) {
        console.error('修改商品失败:', error)
        this.$message.error('修改商品失败')
      }
    },
    
    // 关闭编辑页面
    _closeEditProduct() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
.form-tip {
  margin-top: 8px;
  font-size: 12px;
  color: #909399;
  line-height: 1.5;
}

.ibox {
  margin-bottom: 20px;
}

.flex {
  display: flex;
}

.justify-between {
  justify-content: space-between;
}

/* 表单样式 */
.el-form-item {
  margin-bottom: 20px;
}

.el-form-item:last-child {

}

/* 表格样式 */
.el-table {
  margin-bottom: 20px;
}

/* 按钮样式 */
.el-button + .el-button {
  margin-left: 10px;
}

/* 响应式布局 */
@media (max-width: 768px) {
  .el-form-item {
    margin-bottom: 15px;
  }
  
  .el-col {
    margin-bottom: 10px;
  }
}
</style>